//将字符串formatter函数用eval执行插件
export default {
  methods: {
    formaterControlLenPlugin(opt) {
      opt.xAxis.axisLabel.formatter = function (value, index) {
        if (!opt.xAxis.axisLabel.axisLabelLenControl) {
          return value
        }
        let newVal = ""
        value = value + ""
        let endString = opt.xAxis.axisLabel.axisLabelLen >= value.length ? "" : "..."
        let maxLen = opt.xAxis.axisLabel.axisLabelLen >= value.length ? value.length : opt.xAxis.axisLabel.axisLabelLen
        for (let i = 0; i < maxLen; i++) {
          newVal += value[i]
        }
        return newVal + endString
      }
      if(Array.isArray(opt.yAxis) && opt.yAxis.length && opt.yAxis.length === 2){
        for(let i=0; i< opt.yAxis.length; i++){
          opt.yAxis[i].axisLabel.formatter = function (value, index) {
            if (!opt.yAxis[i].axisLabel.axisLabelLenControl) {
              return value
            }
            let newVal = ""
            value = value + ""
            let endString = opt.yAxis[i].axisLabel.axisLabelLen >= value.length ? "" : "..."
            let maxLen = opt.yAxis[i].axisLabel.axisLabelLen >= value.length ? value.length : opt.yAxis[i].axisLabel.axisLabelLen
            for (let i = 0; i < maxLen; i++) {
              newVal += value[i]
            }
            return newVal + endString
          }
        }
      }else{
        opt.yAxis.axisLabel.formatter = function (value, index) {
          if (!opt.yAxis.axisLabel.axisLabelLenControl) {
            return value
          }
          let newVal = ""
          value = value + ""
          let endString = opt.yAxis.axisLabel.axisLabelLen >= value.length ? "" : "..."
          let maxLen = opt.yAxis.axisLabel.axisLabelLen >= value.length ? value.length : opt.yAxis.axisLabel.axisLabelLen
          for (let i = 0; i < maxLen; i++) {
            newVal += value[i]
          }
          return newVal + endString
        }
      }
    }
  }
}
